export const endSentenceForScreenReaders = (sentence: string) => {
  //The screen reader needs a full stop or question mark or exclamation mark at the end of sentence
  const sentenceHasProperEnd =
    sentence.endsWith('.') || sentence.endsWith('?') || sentence.endsWith('!');
  return sentenceHasProperEnd ? '' : '.';
};
